<template>
  <div>
    <!-- Header -->
    <header class="header">
      <nav class="navbar navbar-default">
        <div class="container">
          <div class="navbar-header">
          <a class="navbar-brand" href="index.html"><img src="../assets/images/logo.png" class="logo" alt=""></a>
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          </button>
          </div>
         <div id="navbar" class="navbar-collapse collapse" aria-expanded="false">
          <ul class="nav navbar-nav navbar-right">
            <li ><a href="index.html">Home</a></li>
            <li><a href="about.html">About</a></li>
            <li><a href="#">Action Plans</a></li>
            <li><a href="#">Projects</a></li>
            <li class="resources active"><a href="#">Resources</a></li>
            <li class="mx-lg-3 btn-cont"><a class="my-1 my-lg-0 btn btn-block btn-primary" href="#"> Sign in</a></li>

             <li class="language dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">EN <span class="caret"></span></a>
              <ul class="dropdown-menu">
              <li><a href="#">English</a></li>
              <li><a href="#">French</a></li>
              <li><a href="#">German</a></li>
              <li><a href="#">Arabic</a></li>
              </ul>
            </li>
          </ul>
          </div>
         </div>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- <style scoped></style> -->



// WEBPACK FOOTER //
// src/elements/Header.vue